<template>
  <div class="categories-section q-mt-xl">
    <h2 class="text-h4 text-weight-bold featured-heading">Shop by Categories</h2>
    <div class="heading-underline q-mb-lg"></div>
    <div v-if="loading" class="row q-col-gutter-md">
      <div class="col-lg-3 col-md-4 col-sm-6" v-for="i in 8" :key="i">
        <q-skeleton height="100px" square />
      </div>
    </div>
    <div v-else-if="error" class="text-center q-pa-xl bg-grey-2 rounded-borders">
      <q-icon name="error_outline" size="3rem" color="negative" />
      <p class="text-h6 text-negative q-mt-md">{{ error }}</p>
      <q-btn label="Try Again" color="primary" @click="$emit('refresh')" class="q-mt-md" no-caps />
    </div>
    <div v-else-if="categories.length === 0" class="text-center q-pa-xl bg-grey-2 rounded-borders">
      <q-icon name="info" size="3rem" color="grey-7" />
      <p class="text-h6 text-grey-7 q-mt-md">No categories available at the moment</p>
    </div>
    <div v-else class="row q-col-gutter-md">
      <div class="col-6 col-sm-6 col-md-4 col-lg-3" v-for="(category, index) in categories" :key="category.id || index">
        <router-link :to="{ name: 'Category', params: { slug: category.url_slug }}" style="text-decoration: none;">
          <q-card 
            class="category-card h-100" 
            :style="`background: ${category.color || '#1976d2'}`" 
            dark 
            bordered
            clickable
            v-ripple
          >
            <q-card-section class="flex items-center">
              <div>
                <div class="text-h6 text-weight-bold">{{ category.name }}</div>
                <div class="text-subtitle2 q-mt-sm">{{ category.coupon_count || 0 }} offers available</div>
              </div>
              <q-space />
              <q-avatar v-if="category.icon" size="56px">
                <q-icon :name="category.icon" />
              </q-avatar>
              <q-avatar v-else size="56px">
                <q-icon name="category" />
              </q-avatar>
            </q-card-section>
          </q-card>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  categories: { type: Array, default: () => [] },
  loading: Boolean,
  error: String,
});
const emit = defineEmits(['refresh']);
</script>
